module.exports = __webpack_public_path__ + "img/chevup_active.51c701fa.svg";